/** Reports ▸ Sub-Bin Card (the old Stores Utility's, user 2026-10-30). Open to Stores View. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { StoresBinCardPage } from "@/features/stores/components/bin-card-page";

const id = z.coerce.number().int().positive().optional().catch(undefined);
export const Route = createFileRoute("/_app/stores/reports/bin-card")({
  validateSearch: z.object({
    whId: id,
    binId: id,
    subBinId: id,
    from: z.iso.date().optional().catch(undefined),
    to: z.iso.date().optional().catch(undefined),
  }),
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <StoresBinCardPage
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
